import React from 'react';
import icArrowLeftDisabled from 'Assets/img/ic_arrow_left_16_disabled@2x.png';
import icSkipLeftLineDisabled from 'Assets/img/ic_skip_left_line_16_disabled@2x.png';
import icArrowRight from 'Assets/img/ic_arrow_right_16_strong@2x.png';
import icSkipRightLine from 'Assets/img/ic_skip_right_line_16_strong@2x.png';

const BasicPagination2 = ({ currentPage, lastPage, onPageClick }) => {
  if (!lastPage) return <></>;
  return (
    <div className={`basic-pagination2`}>
      <div
        className={`basic-pagination2-item no-drag ${currentPage > 1 ? '' : 'isDisabled'}`}
        onClick={e => {
          if (currentPage > 1) onPageClick(e, 1);
        }}
      >
        {currentPage > 1 ? (
          <img src={icSkipRightLine} style={{ transform: 'rotate(180deg)', width: '16px', height: '16px' }} alt='icSkipLeftLine' />
        ) : (
          <img src={icSkipLeftLineDisabled} style={{ width: '16px', height: '16px' }} alt='icSkipLeftLineDisabled' />
        )}
      </div>
      <div
        className={`basic-pagination2-item no-drag ${currentPage > 1 ? '' : 'isDisabled'}`}
        onClick={e => {
          if (currentPage > 1) onPageClick(e, currentPage - 1);
        }}
      >
        {currentPage > 1 ? (
          <img src={icArrowRight} style={{ transform: 'rotate(180deg)', width: '16px', height: '16px' }} alt='icArrow' />
        ) : (
          <img src={icArrowLeftDisabled} style={{ width: '16px', height: '16px' }} alt='icArrowDisabled' />
        )}
      </div>
      {Array.from({ length: lastPage }, (_, index) => {
        const pageNumber = index + 1;
        let startPage = Math.floor((currentPage - 1) / 10) * 10 + 1;
        let endPage = startPage + 9;

        if (endPage > lastPage) {
          endPage = lastPage;
        }

        if (pageNumber >= startPage && pageNumber <= endPage) {
          return (
            <div key={index} className={`basic-pagination2-item no-drag ${pageNumber === currentPage && 'selected'}`} onClick={e => onPageClick(e, pageNumber)}>
              {pageNumber}
            </div>
          );
        }
        return null;
      })}
      <div
        className={`basic-pagination2-item no-drag ${currentPage < lastPage ? '' : 'isDisabled'}`}
        onClick={e => {
          if (currentPage < lastPage) onPageClick(e, currentPage + 1);
        }}
      >
        {currentPage < lastPage ? (
          <img src={icArrowRight} style={{ width: '16px', height: '16px' }} alt='icArrow' />
        ) : (
          <img src={icArrowLeftDisabled} style={{ transform: 'rotate(180deg)', width: '16px', height: '16px' }} alt='icArrowDisabled' />
        )}
      </div>
      <div className={`basic-pagination2-item no-drag ${currentPage < lastPage ? '' : 'isDisabled'}`} onClick={e => onPageClick(e, lastPage)}>
        {currentPage < lastPage ? (
          <img src={icSkipRightLine} style={{ width: '16px', height: '16px' }} alt='icSkipRightLine' />
        ) : (
          <img src={icSkipLeftLineDisabled} style={{ transform: 'rotate(180deg)', width: '16px', height: '16px' }} alt='icSkipLeftLineDisabled' />
        )}
      </div>
    </div>
  );
};

export default BasicPagination2;
